import React from 'react';

function EncounterPage() {
    return (
        <div className="home">
            <h1>Encounter</h1>
        </div>
    );
}

export default EncounterPage;
